jQuery(document).ready(function ($) {
  // //locations dropdown, testing.
  // const params = new URLSearchParams(window.location.search);
  // $("#location-office-types-dropdown").val(params.get("location-office-types"));
  // $("#location-county-dropdown").val(params.get("location-county"));
  // $("#location-office-types-dropdown, #location-county-dropdown").on(
  //   "change",
  //   function () {
  //     console.log("change");
  //     window.location.href =
  //       "/locations-map/?location-office-types=" +
  //       $("#location-office-types-dropdown").val() +
  //       "&location-county=" +
  //       $("#location-county-dropdown").val();
  //   }
  // );
});
